<template>
  <v-container fluid grid-list-sm>
    <v-layout>
      <v-flex xs12 sm12>
        <v-img height="350px" :src="imgFirst">
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
    props: {
        imgFirst: String,
    },
}
</script>

